module.exports = __webpack_public_path__ + "img/c05_unitliburnian_Normal_ua.bf9be94d.webp";